import React from "react";
import { FormWrapper } from "./Contact.styles";
import {Container, Col, Row, Card} from "react-bootstrap";
import 'react-phone-number-input/style.css';
import { Link } from "gatsby";
import GetForm from "./GetForm";
import ContactMap from "./ContactMap"
import TestForm from "./TestForm";


const ContactForm = () => {

   
    return(
        <FormWrapper>
            <Container>
          <Row>
            <Col>
                <div className="contact-desc-text ">
                    <p>Looking for more information? Connect with us at any time..</p>
                    <p>
                    <span>21st Floor, Harbour Towers - East,</span> 
                    <span>Bahrain Financial Harbour, King Faisal Highway,</span> 
                    <span>Building 1398, Road 4626, Block 346, </span>
                    <span>Kingdom of Bahrain </span>
                    </p>
                    <a href="tel:+97377360360"><span>Phone:</span> +973 77 360 360</a>
                    <a href="mailto:info@edxlabs.com"><span>Email:</span> info@edxlabs.com</a>
                </div>
                <ContactMap />
            </Col>
            <Col>
            <TestForm/>

            </Col>
          </Row>
        </Container>
               
           
        </FormWrapper>
    )
}
export default ContactForm;